module.exports = __webpack_public_path__ + "static/img/tit5.0795bb6c.png";